import React from 'react';
import {eviteGreen} from '~sass/OLD/reinvention_styleguide/base/_exports.sass';

export const LinkOutIcon = (props) => {
  const {color = eviteGreen, width = 10.864, height = 10.863, className = ''} = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
    >
      <g>
        <g>
          <path
            d="M65.121,5.915v5.374a.915.915,0,1,1-1.831,0V8.125l-7.467,7.47a.925.925,0,0,1-.647.269.917.917,0,0,1-.647-1.565L62,6.831H58.834a.915.915,0,0,1,0-1.831h5.371a1.126,1.126,0,0,1,.174.015,1.09,1.09,0,0,1,.171.052l.079.037a.9.9,0,0,1,.223.165.91.91,0,0,1,.253.473.894.894,0,0,1,.012.091s0,0,0,.006A.632.632,0,0,1,65.121,5.915Z"
            transform="translate(-54.259 -5)"
            fill={color}
          />
        </g>
        <g transform="translate(10.859 0.839)">
          <path
            d="M94.982,8.223v.089a1,1,0,0,0,0-.165A.632.632,0,0,1,94.982,8.223Z"
            transform="translate(-94.979 -8.147)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
